// PrinterList.jsx
import React, { useEffect, useState } from 'react';
import { fetchLivePrinters, triggerPrinterRescan } from './api';
import PrinterRow from './PrinterRow';
import { useOrg } from '../orgs/org-context';

export default function PrinterList() {
  const [printers, setPrinters] = useState([]);
  const [status, setStatus] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const { activeOrg } = useOrg();

  const loadPrinters = async () => {
    const res = await fetchLivePrinters();
    if (!res) {
      console.warn("Using previous printer state (network glitch)");
      return; // 🔥 don't overwrite state
    }
    setPrinters(res || []);
    setLastUpdated(new Date());
  };

  const handleRescan = async () => {
    setStatus('Rescanning...');
    const orgId = activeOrg._id || '';
    try {
      const res = await triggerPrinterRescan(orgId);
      console.log("res:", res)
      if (res.ok) {
        await loadPrinters();
        setStatus('Rescan complete ✅');
      } else {
        setStatus('Rescan failed ❌');
      }
    } catch (err) {
      console.error('Rescan error:', err);
      setStatus('Rescan failed ❌');
    }
    setTimeout(() => setStatus(null), 3000);
  };

  useEffect(() => {
    loadPrinters();
    const interval = setInterval(loadPrinters, 10000); // 10s polling
    return () => clearInterval(interval);
  }, [activeOrg]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button onClick={handleRescan}>🔄 Rescan</button>
        {lastUpdated && (
          <span style={{ fontSize: '0.8rem', color: '#888' }}>
            Last updated: {lastUpdated.toLocaleTimeString()}
          </span>
        )}
      </div>

      {status && <div style={{ marginTop: '5px', fontStyle: 'italic' }}>{status}</div>}

      <table className="pm-table">
        <thead>
          <tr>
            <th>Printer</th>
            <th>Status</th>
            <th>Queue</th>
            <th>Last Job</th>
            <th>Device</th>
          </tr>
        </thead>
        <tbody>
          {printers.map(p => (
            <PrinterRow
              key={`${p.deviceId}:${p.printerId}`}
              printer={p}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}
